export default defineNuxtRouteMiddleware(() => {
  if (import.meta.client) {
    document.dispatchEvent(new Event('lbx:page:load'));
  }
});
